import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "speech-bubble-tail",
  "use": "speech-bubble-tail-usage",
  "viewBox": "0 0 27 17",
  "content": "<symbol viewBox=\"0 0 27 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"speech-bubble-tail\">\n<path d=\"M26.5 1C20.5 2.01 17 7.03 18.5 11.56C20.03 16.17 10.5 6.72 6.76 3.51C5 2.01 3 1 0 1V0H26.5Z\" fill=\"#C9F0FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol